import {LitElement, html, unsafeCSS} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import socialCss from "./bg-social-media-share.scss?inline"

export interface BgSocialMediaShareInterface {
  title: string,
}


@customElement('bg-social-media-share')
export class BgSocialMediaShare extends LitElement {

  constructor(args:BgSocialMediaShareInterface) {
    super();
    if(!args) {
      return
    };
    this.title = args.title;
  }

  @property()
  docsHint = '';
  
  @property({ type: String })
  title = "Share";

  render() {
    return html`
      <div class="social-media-share-container-horizontal">
        <span class="social-share-links-title-horizontal">${this.title}</span>
        <div class="social-media-icon-horizontal">
          <slot></slot>
        </div>
      </div>
    `
  }
  
  static styles = [
    unsafeCSS(socialCss),
  ]
}

declare global {
  interface HTMLElementTagNameMap {
    'bg-social-media-share': BgSocialMediaShare
  }
}
